import { render, staticRenderFns } from "./PageWrapper.vue?vue&type=template&id=a441c630&scoped=true"
import script from "./PageWrapper.vue?vue&type=script&lang=js"
export * from "./PageWrapper.vue?vue&type=script&lang=js"
import style0 from "./PageWrapper.vue?vue&type=style&index=0&id=a441c630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a441c630",
  null
  
)

export default component.exports